var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripleDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H104C112.837 0 120 7.16344 120 16V100C120 133.137 93.1371 160 60 160C26.8629 160 0 133.137 0 100V16Z",
    fill: "#D1B277"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19C4 11.268 10.268 5 18 5H102C109.732 5 116 11.268 116 19V100C116 130.928 90.928 156 60 156C29.0721 156 4 130.928 4 100V19Z",
    fill: "url(#paint0_linear_12_2111)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "url(#paint1_linear_12_2111)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 113.643L35 78.8214H44.4595L60 99.3571V113.643Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 44L35 78.8214H44.4595L60 58.2857V44Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 113.643L85 78.8214H75.5405L60 99.3571V113.643Z",
    fill: "#9F9F9F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 44L85 78.8214H75.5405L60 58.2857V44Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4727 78.8202L60.0132 58.2845L75.5537 78.8202L60.0132 99.3559L44.4727 78.8202Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 122.061L76 106.03H80.3514L87.5 115.484V122.061Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 90L76 106.03H80.3514L87.5 96.5765V90Z",
    fill: "#F8F8F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 122.061L99 106.03H94.6486L87.5 115.484V122.061Z",
    fill: "#9F9F9F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 90L99 106.03H94.6486L87.5 96.5765V90Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3574 106.03L87.5061 96.576L94.6547 106.03L87.5061 115.484L80.3574 106.03Z",
    fill: "#E6E6E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 122.061L21 106.03H25.3514L32.5 115.484V122.061Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 90L21 106.03H25.3514L32.5 96.5765V90Z",
    fill: "#F8F8F8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 122.061L44 106.03H39.6486L32.5 115.484V122.061Z",
    fill: "#9F9F9F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 90L44 106.03H39.6486L32.5 96.5765V90Z",
    fill: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3574 106.03L32.5061 96.576L39.6547 106.03L32.5061 115.484L25.3574 106.03Z",
    fill: "#E6E6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2111",
    x1: 6.24,
    y1: 8.99815,
    x2: 35.479,
    y2: 114.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#CFB58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED4A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_2111",
    x1: 60,
    y1: 29,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBAB7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripleDiamond);
export default __webpack_public_path__ + "static/media/tripleDiamond.7a5919001ab2e1e01295a12c1a89da2a.svg";
export { ForwardRef as ReactComponent };